// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"logoTitle__wrapper___32sG4","name":"logoTitle__name___3_ywM"};